export const GET_ESHOP_CATEGORIES = 'GET_ESHOP_CATEGORIES'
